import { AppError } from "@/core/common/http/errors/app.error";

export class ForbiddenError extends AppError {
  constructor(message: string, url: string) {
    super(message, 403, "Forbidden", url, "No tienes permisos para acceder aquí");
  }
}
